import * as v from 'valibot';

const ActivityItem = v.object({
	activity: v.string(),
	content: v.optional(v.string()),
	createdDate: v.string(),
	username: v.string(),
});

export const Activity = v.array(ActivityItem);

export type ActivityItem = v.InferOutput<typeof ActivityItem>;
export type Activity = v.InferOutput<typeof Activity>;
